<template>
    <a class="btn btn-secondary mb-2" :href="route_back">Вернуться</a>

    <div class="title_block d-flex">
        <div class="left_i col-lg-10 d-flex align-items-center">
            <h2>{{name}}</h2>
        </div>
    </div>

    <div class="inform col-md-4 col-12">

        {{text}}

    </div>

</template>

<script>
import Notification from "../../../../models/Notification";

export default {
    name: "NotificationDetailComponent",
    props: {
        route_back: String,
        route_get: String,
        route_readed: String,
        notification_id: {
            type: [Number, String],
            default: 0
        }
    },
    data: function () {
        return {
            notification: new Notification({
                route_get: this.route_get
            }),
            name: '',
            text: '',
            display_at: '',
            hide_at: '',
            pinned: ''
        }
    },
    methods: {
        itemGet: async function () {
            let item = await this.notification.get(this.notification_id);
            this.name = item.name;
            this.text = item.text;
            this.display_at = item.display_at;
            this.hide_at = item.hide_at;
            this.pinned = item.pinned;
        },
        readed: async function () {
            setTimeout(() => {
                this.notification.readed_notify(this.route_readed, this.notification_id);
            }, 5000)
        }
    },
    mounted() {
        this.readed();
        this.itemGet();
    }
}
</script>

<style scoped>

</style>
